<template>
  <div class="p-6 flex-grow-1 container-p-y">
    <channelAdd @updated="fetchChannels" />

    <div class="card">
      <div class="card-datatable">
        <div class="dataTables_wrapper dt-bootstrap5 no-footer">
          <div class="row mx-1" bis_skin_checked="1">
            <div
              v-if="hasPrivilege('settings_iptv')"
              class="mt-5 mb-5 col-12 col-md-12 d-flex align-items-center justify-content-center flex-column  gap-2"
              bis_skin_checked="1"
            >
              <div class="form-check custom-option custom-option-basic">
                <label
                  id="iptv-enbale"
                  class="form-check-label custom-option-content"
                  for="appallowed"
                >
                  <input
                    name="apppermissions"
                    class="form-check-input mx-2"
                    type="checkbox"
                    id="appallowed"
                    @change="toggleStatus"
                    v-model="status"
                  />
                  <span class="custom-option-header">
                    <span class="h6 mb-0 d-flex align-items-center">{{
                      $t("iptv.enabled")
                    }}</span>
                  </span>
                </label>
              </div>
              <div
                class="dt-action-buttons text-xl-end text-lg-start text-md-end text-start mt-2"
                bis_skin_checked="1"
              >
                <div
                  class="dt-buttons btn-group flex-wrap"
                  bis_skin_checked="1"
                >
                  <button
                    class="btn btn-primary btn-lg waves-effect waves-light"
                    tabindex="0"
                    aria-controls="DataTables_Table_0"
                    type="button"
                    data-bs-toggle="modal"
                    data-bs-target="#add-channel"
                    :disabled="
                      !this.$store.getters.settings.license.active || !status
                    "
                  >
                    <span>
                      <i class="ti ti-plus ti-xs me-2"></i>
                      <span class=" ">{{ $t("iptv.add_channel") }}</span>
                    </span>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div class="dataTables_scroll" bis_skin_checked="1">
            <div
              class="dataTables_scrollBody table-container"
              bis_skin_checked="1"
              style="position: relative; overflow: auto; width: 100%; height: 480px;"
            >
              <table
                class="dt-scrollableTable table"
                id="DataTables_Table_0"
                aria-describedby="DataTables_Table_0_info"
              >
                <thead
                  style="background-color: var(--bs-card-bg);"
                  class="sticky top-0 z-50"
                >
                  <tr class="text-nowrap">
                    <th></th>
                    <th class="sorting">{{ $t("iptv.logo") }}</th>
                    <th class="sorting">{{ $t("iptv.name") }}</th>
                    <th class="sorting">{{ $t("iptv.url") }}</th>
                  </tr>
                </thead>
                <tbody class="table-border-bottom-0 ">
                  <tr v-for="(channel, index) in channels" v-bind:key="index">
                    <td scope="row">
                      <div class="dropdown">
                        <button
                          type="button"
                          class="btn p-0 dropdown-toggle hide-arrow"
                          data-bs-toggle="dropdown"
                        >
                          <i class="ti ti-dots-vertical"></i>
                        </button>
                        <ul class="dropdown-menu">
                          <li v-if="hasPrivilege('settings_iptv')">
                            <button
                              @click="showDeleteDialog(channel)"
                              class="dropdown-item text-danger"
                              href="#"
                            >
                              <i class="ti ti-trash me-2"></i
                              >{{ $t("actions.delete") }}
                            </button>
                          </li>
                        </ul>
                      </div>
                    </td>

                    <td>
                      <div
                        class="m-0 d-flex align-items-center avatar-group justify-content-center"
                      >
                        <div
                          class="pull-up"
                          style="width: 100px; height: 100%;"
                          v-if="channel.logo"
                        >
                          <img
                            class=""
                            :src="server_url + channel.logo"
                            alt="Avatar"
                          />
                        </div>
                      </div>
                    </td>
                    <td>{{ channel.name }}</td>
                    <td>
                      <a :href="channel.url" class=" text-blue-700 underline">{{
                        channel.url
                      }}</a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <!-- <div class="row mx-1" bis_skin_checked="1">
            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_info"
                id="DataTables_Table_0_info"
                role="status"
                aria-live="polite"
                bis_skin_checked="1"
              >
                {{
                  $t("control.pagination", {
                    from: meta.from,
                    to: meta.to,
                    total: meta.total,
                  })
                }}
              </div>
            </div>

            <div class="col-sm-12 col-md-6" bis_skin_checked="1">
              <div
                class="dataTables_paginate paging_simple_numbers"
                id="DataTables_Table_0_paginate"
                bis_skin_checked="1"
              >
                <ul class="pagination">
                  <li
                    :class="{ disabled: filters.page < 2 }"
                    class="paginate_button page-item previous"
                    id="DataTables_Table_0_previous"
                  >
                    <a
                      @click.prevent="
                        filters.page = filters.page - 1;
                        applyFilters;
                      "
                      aria-controls="DataTables_Table_0"
                      aria-disabled="true"
                      role="link"
                      data-dt-idx="previous"
                      tabindex="-1"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-left ti-sm"></i>
                    </a>
                  </li>
                  <li
                    class="paginate_button page-item"
                    :class="{
                      active: link.label == filters.page,
                      disabled: link.url == null,
                    }"
                    v-for="(link, index) in meta.links"
                    :key="index"
                  >
                    <a
                      v-if="index != 0 && index < meta.links.length - 1"
                      @click.prevent="
                        filters.page = link.label;
                        applyFilters();
                      "
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      aria-current="page"
                      data-dt-idx="0"
                      tabindex="0"
                      class="page-link"
                      >{{ link.label }}</a
                    >
                  </li>
                  <li
                    :class="{
                      disabled: meta.current_page == meta.last_page,
                    }"
                    class="paginate_button page-item next"
                    id="DataTables_Table_0_next"
                  >
                    <a
                      href="#"
                      aria-controls="DataTables_Table_0"
                      role="link"
                      data-dt-idx="next"
                      tabindex="0"
                      class="page-link"
                    >
                      <i class="ti ti-chevron-right ti-sm"></i>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import channelAdd from "../components/modals/channel-add.vue";
import { mapGetters } from "vuex";
import { hasPrivilege } from "../global_constants.js";
export default {
  components: {
    channelAdd,
  },
  name: "IPTV",
  computed: {
    ...mapGetters(["settings", "user"]),
  },
  data() {
    return {
      dma: null,
      loading: false,
      message: "",
      sessions: false,
      channels: [],
      showDelete: false,
      showAdd: false,
      server_url: localStorage.getItem("server"),
      selectedData: null,
      status: false,
    };
  },
  async created() {
    await this.fetchChannels();
  },
  methods: {
    hasPrivilege(privilege) {
      return hasPrivilege(this.user, privilege);
    },
    selectFile() {
      this.dma = this.$refs.dmaFile.files.item(0);
    },
    async fetchChannels() {
      this.loading = true;
      const response = await axios.get("iptv");
      this.channels = response.data.data;
      const response2 = await axios.get("iptv/status");
      this.status = response2.data.data == 1;
      this.loading = false;
    },
    async showDeleteDialog(channel) {
      this.$swal({
        title: this.$t("iptv.delete_channel") + " " + channel.name,
        text: this.$t("iptv.this_will_delete_selected_channel"),
        icon: "question",
        showCancelButton: true,
        confirmButtonText: this.$t("iptv.yes_delete_it"),
        cancelButtonText: this.$t("control.no"),
        reverseButtons: true,
        backdrop: true,
        buttonsStyling: false,
        customClass: {
          confirmButton: "btn btn-label-danger",
          cancelButton: "btn btn-label-secondary",
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await axios.post(`iptv/${channel.id}`);
            if (response.status == 200) {
              this.fetchChannels();
            }
            this.$swal({
              title: this.$t("control.success"),
              text: this.$t("iptv.channel_deleted_successfully"),
              icon: "success",
              timer: 1500,
              showConfirmButton: false,
              backdrop: true,
            });
          } catch (error) {
            this.$swal({
              title: this.$t("control.error"),
              text:
                error.response?.data?.message ||
                this.$t("control.some_thing_went_wrong_please_try_again"),
              icon: "error",
              confirmButtonText: this.$t("control.ok"),
              backdrop: true,
            });
          }
        }
      });
    },
    async toggleStatus() {
      this.loading = true;
      const response = await axios.post("iptv/enable");
      if (response.status == 200) {
        this.$router.push({
          path: "/iptv",
          query: { success: "success" },
        });
      }
      this.loading = false;
      this.fetchChannels();
    },
    async deleteData() {
      this.showDelete = false;
      this.loading = true;
      const response = await axios.post(`iptv/${this.selectedData.id}`);
      if (response.status == 200) {
        this.fetchChannels();
      }
      this.loading = false;
    },
  },
};
</script>
